export const FIELD_DATA = 'FIELD_DATA';
export const ADD_FIELD_DATA = 'ADD_FIELD_DATA';
export const UPDATE_FIELD_DATA = 'UPDATE_FIELD_DATA';
export const DELETE_FIELD = 'DELETE_FIELD';
